import { useEffect, useState } from 'react';

/**
 * SEOフッターリンク表示の判定
 * @param totalCount 求人件数
 * @returns SEOフッターリンク表示フラグ
 */
export const useIsShowSeoFooterLink = (totalCount: number) => {
  const [addressBarUl, setAddressBarUl] = useState<string>('');
  const [canonicalUrl, setCanonicalUrl] = useState<string>('');

  useEffect(() => {
    const canonicalElem = document.querySelector(
      'link[rel="canonical"]'
    ) as HTMLLinkElement;
    setAddressBarUl(window.location?.pathname);
    setCanonicalUrl(canonicalElem?.href.replace(/.*DodaFront/, '/DodaFront'));
  }, []);

  const isShowSeoFooterLink = addressBarUl === canonicalUrl && totalCount > 0;

  return isShowSeoFooterLink;
};
